import {getMethod} from '~/api'

async function get(request, cancelToken) {
    return await getMethod('/proxy/searchFlightSchedule', request, cancelToken)
}

export {get}
